import classNames from 'classnames';
import {
  BLOG_BLOCK_NAME,
  BLOG_PREFIX,
  BLOG_SECTION_NAME,
  PAGE_SECTION_NAME,
} from './common/constants';

import css from './common/styles.module.css';

export const getCustomBlockStyle = block => {
  const { blockName } = block;
  switch (blockName) {
    case BLOG_BLOCK_NAME.BLOG_AUTHOR:
      return {
        className: css.blogAuthorContainer,
        mediaClassName: css.blogAuthorMedia,
        textClassName: css.blogAuthorText,
      };
    case BLOG_BLOCK_NAME.BLOG_SUBTITLE:
      return {
        textClassName: css.blogSubtitle,
      };
    case BLOG_BLOCK_NAME.BLOG_POST:
      return {
        textClassName: css.blogPost,
      }
    case BLOG_BLOCK_NAME.BLOG_CONTENT_BLOCK:
      return {
        textClassName: css.blogContentText,
      }
    default:
      return {};
  }
};

export const getCustomSectionClasses = (section, defaultClasses) => {
  const {
    sectionDetails: defaultSectionDetailsClass,
  } = defaultClasses;
  const { sectionName } = section;

  switch (sectionName) {
    case PAGE_SECTION_NAME.PAGE_HEADER:
    case BLOG_SECTION_NAME.BLOG_HEADER:
    case BLOG_SECTION_NAME.BLOG_CONTENT:
      return {
        ...defaultClasses,
        title: css.blogSectionTitle,
        sectionDetails: classNames(defaultSectionDetailsClass, css.blogSectionDetails),
        blockContainer: css.blogBlockContainer,
      };
    case BLOG_SECTION_NAME.BLOG_SIMILAR_POSTS:
      return {
        ...defaultClasses,
        title: css.blogSectionTitle,
        sectionDetails: classNames(defaultSectionDetailsClass, css.blogSectionDetails),
        blockContainer: classNames(css.blogBlockContainer, css.blogSimilarPostBlockContainer),
      };
    
    case PAGE_SECTION_NAME.PAGE_CONTENT:
      return {
        ...defaultClasses,
        title: css.blogSectionTitle,
        blockContainer: css.pageBlockContainer
      };

    case PAGE_SECTION_NAME.PAGE_CONTENT_PHOTOS:
      return {
        ...defaultClasses,
        blockContainer: css.photosBlockContainer,
      };
    default:
      return defaultClasses;
  }
};

export const getCustomSectionClassName = section => {
  const { sectionName = '' } = section;

  if (sectionName.includes(BLOG_PREFIX)) {
    return css.customSection;
  }

  switch (sectionName) {
    case PAGE_SECTION_NAME.PAGE_HEADER:
    case PAGE_SECTION_NAME.PAGE_CONTENT:
      return css.customPageSection;
    case PAGE_SECTION_NAME.PAGE_CONTENT_PHOTOS:
      return css.customPhotosSection;
    default:
      return '';
  }
}